import * as localStorage from '@/services/localStorage';
import * as sessionStorage from '@/services/sessionStorage';

const BY_DATE_KEY = 'nikeone.settings.prematch.byDate';
const PREMATCH_ONLY_KEY = 'nikeone.settings.prematch.prematchOnly';

export const prematchSession = {
    byDate: {
        save: function(byDate) {
            return byDate ? sessionStorage.setObject(BY_DATE_KEY, byDate) : sessionStorage.removeKey(BY_DATE_KEY);
        },
        load: function() {
            return sessionStorage.getObject(BY_DATE_KEY);
        }
    },
    prematchOnly: {
        save: function(value) {
            return value ? localStorage.setObject(PREMATCH_ONLY_KEY, value) : localStorage.removeKey(PREMATCH_ONLY_KEY);
        },
        load: function() {
            return !!localStorage.getObject(PREMATCH_ONLY_KEY);
        }
    }
};
